export default __webpack_public_path__ + "static/media/Snd3.97c33ba8.mp3";